import React from 'react';
import { Button } from 'antd';
import { GetAuthDataValue } from './getAuthCom';

/**
 * 参数
 * @AuthshowType 按钮权限展示类型 值 为 disabled 则为 禁用类型, 否则为 按钮不显示
 * @type 按钮样式 默认值为 'primary'
 * @ButtonId 用户中心配置的权限的操作编码
 *
 * 用法
 * @withGetAuthWraper withGetAuthWraper注入到对应菜单的根页面
 * @示例 import getAuth from './getAuthCom.js'
 *       import NewButton from '../xxxx/xxxx/withAuthButton'
 *       const { withGetAuthWraper } = getAuth
 *        @withGetAuthWraper
 *        class Xxx extends React.Component{
 *          render() {
 *            return <NewButton onClick={....}  ButtonId='add'>添加</NewButton>
 *          }
 *        } .....
 */

function withButton(A) {
  return class extends React.Component {
    render() {
      return (
        <GetAuthDataValue.Consumer>
          {AuthData => <A AuthData={AuthData} {...this.props} />}
        </GetAuthDataValue.Consumer>
      );
    }
  };
}
class NewButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  componentDidMount() {
    const { AuthData, ButtonId } = this.props;
    this.isShowButton(ButtonId, AuthData);
  }

  isShowButton = (ButtonId, AuthData = []) => {
    const arr = [];
    AuthData.map(item => arr.push(item.menuCode));
    if (arr.includes(ButtonId)) {
      this.setState({
        isShow: true,
      });
    } else {
      this.setState({
        isShow: false,
      });
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { AuthData, ButtonId } = nextProps;
    this.isShowButton(ButtonId, AuthData);
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { ButtonId, AuthData, type, AuthshowType, showOthersReactNode, ...othrers } = this.props;
    const { isShow } = this.state;

    if (AuthshowType && AuthshowType === 'disabled') {
      return !isShow ? (
        <Button disabled={AuthshowType} type={type || 'primary'} {...othrers} />
      ) : (
        <Button type={type || 'primary'} {...othrers} />
      );
    } else if (showOthersReactNode && showOthersReactNode == true) {
      return isShow ? <div {...othrers}>{this.props.children}</div> : null;
    } else {
      return isShow ? <Button type={type || 'primary'} {...othrers} /> : null;
    }
  }
}

export default withButton(NewButton);
